module.exports = __webpack_public_path__ + "img/es-ga.18668529.svg";